import dayjs from "dayjs";
import { DateFormats } from "us.common/constants";

export function AddDelayPayment(this: any , caseId: number, entityType: string) {
  return {
    caseNo: caseId,
    delayUntil: dayjs(this.delayUntil).format(DateFormats.FORMAT_1),
    comment: this.comment,
    entityType: entityType
  };
}